<template>
  <div class="sld_collect_index">
    <!-- 会员订单信息 -->

    <div class="user_order">
      <div class="my_order fl">
        <div class="user_avatar_r" v-if="memberInfo.info.memberNickName">
          {{ L['欢迎回来'] }}, 
          <b>{{ memberInfo.info.memberNickName }}</b>
        </div>
        <div class="order_state_nav">
          <router-link :to="'/member/order/list?orderState=10'" target="_blank">
            <div class="item">
              <!-- <i class="iconfont icon-dengdaiwenjian await_pay"></i> -->
              <img src="@/assets/user_center/await_pay.png" alt="" />
              <div class="item_right">
                <p>{{ L['待支付'] }}</p>
                <div class="tag" v-if="memberInfo.info.toPaidOrder > 0">
                  {{ memberInfo.info.toPaidOrder }}
                </div>
              </div>
            </div>
          </router-link>

          <router-link :to="'/member/order/list?orderState=30'" target="_blank">
            <div class="item">
              <!-- <i class="iconfont icon-daishouhuo await_received"></i> -->
              <img src="@/assets/user_center/received.png" alt="" />
              <div class="item_right">
                <p>{{ L['待收货'] }}</p>
                <div class="tag" v-if="memberInfo.info.toReceivedOrder > 0">
                  {{ memberInfo.info.toReceivedOrder }}
                </div>
              </div>
            </div>
          </router-link>

          <router-link
            :to="'/member/order/list?orderState=40&evaluateState=1'"
            target="_blank"
          >
            <div class="item">
              <!-- <i class="iconfont icon-gouwuche_daipingjia await_evaluate"></i> -->
              <img src="@/assets/user_center/tocharge.png" alt="" />
              <div class="item_right">
                <p>{{ L['待评价'] }}</p>
                <div class="tag" v-if="memberInfo.info.toEvaluateOrder > 0">
                  {{ memberInfo.info.toEvaluateOrder }}
                </div>
              </div>
            </div>
          </router-link>

          <router-link :to="'/member/order/aftersales'" target="_blank">
            <div class="item">
              <!-- <i class="iconfont icon-shouhou after_sale"></i> -->
              <img src="@/assets/user_center/aftersale.png" alt="" />
              <div class="item_right">
                <p>{{ L['售后/退货'] }}</p>
                <div class="tag" v-if="memberInfo.info.toEvaluateOrder > 0">
                  {{ memberInfo.info.toEvaluateOrder }}
                </div>
              </div>
            </div>
          </router-link>

          <!-- <router-link :to="'/member/order/list'" target="_blank">
            <div class="item">
              <img
                class="all_order_i"
                src="@/assets/user_center/allorder.png"
                alt=""
              />
              <p class="item_right all_order">{{ L['全部订单'] }}</p>
            </div>
          </router-link> -->

          <router-link :to="'/member/order/aftersales'" target="_blank">
            <div class="item">
              <img src="@/assets/user_center/allorder.png" alt="" />
              <div class="item_right">
                <p>{{ L['全部订单'] }}</p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="my_follow fr"></div>
    </div>
    <!-- 热销推荐 -->
    <div class="content">
      <div class="user_hot_goods">
        <h3>{{ L['热销推荐'] }}</h3>
        <div class="hot_recommend">
          <div
            class="item clearfix"
            v-for="({ goodsImage, goodsName, defaultProductId },
            index) in hotRecom.goods"
            :key="index"
          >
            <a @click="toProductDetail(defaultProductId)">
              <div class="img">
                <img class="lazy" :src="goodsImage" alt="" />
              </div>
              <p class="hot_goods_name">
                {{ goodsName }}
              </p>
              <!-- <p class="hot_goods_price">
                $<em>{{ goodsPrice }}</em>
              </p> -->
            </a>
          </div>
        </div>
      </div>
      <!-- 公告信息 -->
      <div class="my_follow_item footprint">
        <h3 class="user_title">
          {{ L['公告信息']
          }}<router-link class="look_more" :to="'/goods/zixun'" target="_blank"
            >{{ L['查看更多'] }}></router-link
          >
        </h3>
        <div class="tabs">
          <el-tabs
            style="padding: 0 20px"
            v-model="activeName"
            @tab-click="aaa"
          >
            <el-tab-pane
              :label="item.cateName"
              :name="item.id"
              v-for="item in list"
              :key="item.id"
            >
              <div
                class="lists"
                v-for="item2 in list2"
                :key="item2.id"
                @click="navtop(item2)"
              >
                <div class="oooodivspan">{{ item2.title }}</div>
                <div v-html="item2.createTime" class="createTime"></div>
                <!-- <div>{{ item2.createTimeaaa }}</div> -->
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive, onMounted, getCurrentInstance, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'index',
  setup () {
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const list = ref([
      {
        cateId: '',
        cateName: L['全部']
      }
    ])
    const list2 = ref([])
    const router = useRouter()
    const store = useStore()
    const memberInfo = reactive({ info: {} })
    const looklog = reactive({ log: [] })
    const looklogLen = ref(0)
    const cartData = reactive({ data: [] })
    const cartLen = ref(0)
    const num = ref('')
    const collectStore = reactive({ store: [] })
    const collectGoods = reactive({ goods: [] })
    const hotRecom = reactive({ goods: [] })
    const order = reactive({ list: [] })

    const getInitInfo = () => {
      //获取会员信息数据
      proxy.$get('/v3/member/front/member/getInfo').then(res => {
        if (res.state == 200) {
          memberInfo.info = res.data
          store.commit('updateMemberInfo', memberInfo.info) //将购物车数据存储到vuex的store中
        }
      })
    }

    const getLookLog = () => {
      //获取我的足迹数据
      proxy.$get('/v3/member/front/productLookLog/list').then(res => {
        if (res.state == 200) {
          looklog.log = res.data.list[0]
            ? res.data.list[0].productLookLogInfoList.slice(0, 4)
            : []
          looklogLen.value = res.data.list[0]
            ? res.data.list[0].productLookLogInfoList.length
            : 0
        }
      })
    }

    const getCartItem = () => {
      proxy.$get('/v3/business/front/cart/cartList').then(res => {
        if (res.state == 200) {
          cartData.data = res.data ? res.data : []
          cartLen.value = res.data ? res.data.availableCartNum : 0
        }
      })
    }

    const getCollectStore = () => {
      proxy.$get('/v3/member/front/followStore/list').then(res => {
        if (res.state == 200) {
          collectStore.store = res.data.storeList
        }
      })
    }

    const getCollectGoods = () => {
      proxy.$get('/v3/member/front/followProduct/list').then(res => {
        if (res.state == 200) {
          collectGoods.goods = res.data.list
        }
      })
    }

    const getHotReco = () => {
      //获取热门推荐数据
      let params = {
        queryType: 'cart'
      }
      proxy.$get('/v3/goods/front/goods/recommendList', params).then(res => {
        if (res.state == 200) {
          hotRecom.goods = res.data.list
          hotRecom.goods.map(
            item => (item.goodsPrice = new Number(item.goodsPrice).toFixed(2))
          )
        }
      })
    }

    const getOrder = () => {
      //获取订单
      let params = {
        current: 1
      }
      proxy.$get('/v3/business/front/orderInfo/list', params).then(res => {
        if (res.state == 200) {
          order.list = res.data.list
          order.list.map(
            item => (item.totalMoney = new Number(item.totalMoney).toFixed(2))
          )
        }
      })
    }

    const seeOrderDetail = (orderSn, inquiryId) => {
      //去往订单详情
      let newWin = router.resolve({
        path: 'order/detail',
        query: {
          orderSn: orderSn,
          inquiryId: inquiryId
        }
      })
      window.open(newWin.href, '_blank')
    }

    const toProductDetail = productId => {
      let newWin = router.resolve({
        path: '/goods/detail',
        query: {
          productId: productId
        }
      })
      window.open(newWin.href, '_blank')
    }
    const getInial2 = () => {
      let params = {
        cateId: ''
      }
      proxy.$get('/v3/cms/front/information/cateList', params).then(res => {
        for (let index = 0; index < res.data.length; index++) {
          list.value.push(res.data[index])
        }
      })
    }
    const getInial = () => {
      if (num.value == '') {
        let params = {}
        proxy.$get('/v3/cms/front/information/list', params).then(res => {
          list2.value = res.data.informationList
          console.log(list2.value)
        })
      } else {
        let params = {
          cateId: num.value
        }
        proxy.$get('/v3/cms/front/information/list', params).then(res => {
          list2.value = res.data.informationList
          console.log(list2.value)
        })
      }
    }
    // const getInial = () => {
    //   if (num.value == '') {
    //     let params = {}
    //     // let arr = []
    //     proxy.$get('/v3/cms/front/information/list', params).then(res => {
    //       // list2.value = res.data.informationList
    //       res.data.informationList.forEach(item => {
    //         let createTime = item.createTime.split(' ')[0]
    //         item = { ...item, createTimeaaa: createTime }
    //         list2.value.push(item)
    //         // arr.push(item)
    //         // list2.value = arr
    //         // console.log('list2.value---000---', list2.value)
    //       })
    //     })
    //   } else {
    //     let params = {
    //       cateId: num.value
    //     }
    //     proxy.$get('/v3/cms/front/information/list', params).then(res => {
    //       // list2.value = res.data.informationList
    //       res.data.informationList.forEach(item => {
    //         let createTime = item.createTime.split(' ')[0]
    //         item = { ...item, createTimeaaa: createTime }
    //         list2.value.push(item)
    //       })
    //       console.log('list2.value---111---', list2.value)
    //     })
    //   }
    // }
    const navtop = item => {
      router.push({
        path: `/goods/zixunxq`,
        query: { informationId: item.informationId }
      })
    }
    const aaa = e => {
      list.value.forEach(res => {
        if (res.cateName == e.props.label) {
          num.value = res.cateId
          console.log('num.value---000', num.value)
        }
      })
      getInial()
    }

    onMounted(() => {
      getInitInfo()
      getLookLog()
      getHotReco()
      getOrder()
      getCartItem()
      getCollectStore()
      getCollectGoods()
      getInial()
      getInial2()
    })

    return {
      aaa,
      num,
      list,
      list2,
      getInial2,
      getInial,
      memberInfo,
      navtop,
      L,
      looklog,
      hotRecom,
      getOrder,
      order,
      seeOrderDetail,
      toProductDetail,
      looklogLen,
      cartData,
      cartLen,
      collectStore,
      collectGoods
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/style/member/index.scss';
@import '@/style/base.scss';

.user_order_empty {
  padding: 90px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;

  p {
    margin-left: 12px;
    color: #666666;
  }
}

.no_footprint {
  height: 73px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.acco_item2 {
  width: 33% !important;
}
.loc {
  color: #ffffff;
  margin-top: 20px;
}
.lists {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
}
.yy {
  color: #ffffff;
}
.oooodivspan {
  width: 160px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.createTime {
  overflow: hidden;
  text-align: right;
}
.await_evaluate {
  color: #abc49e !important;
}
.await_received {
  color: #7076e8 !important;
}
.await_pay {
  color: #3981f4 !important;
  font-size: 35px !important;
}
.after_sale {
  color: #637986 !important;
  font-size: 50px !important;
}
</style>
